import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  salesData: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",

  isFetchingUserList: false,

  createSale: {},
  isSuccessCreateSale: false,
  isErrorCreateSale: false,
  isErrorMessageCreateSale: "",

  deleteSale: {},
  isSuccessDeleteSale: false,
  isErrorDeleteSale: false,
  isErrorMessageDeleteSale: "",

  editSale: {},
  isSuccessEditSale: false,
  isErrorEditSale: false,
  isErrorMessageEditSale: "",
};

export const getSalesData = createAsyncThunk(
  "sales/get-all-sales",
  async (params = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const {
        pageNumber = 0,
        pageSize = 10,
        sortBy = "id",
        sortDirection = "DESC",
        searchTerm,
        masterId,
        userName,
        role,
      } = params;

      const backendSortFieldMap = {
        userName: "userName", 
        masterId: "masterId",
        role: "role",
        id: "id",
      };
      const backendSortBy = backendSortFieldMap[sortBy] || sortBy;

      let url = `/sales/salesUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${backendSortBy}&sortDirection=${sortDirection.toUpperCase()}`;
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      
      if (masterId && masterId.trim() !== "") {
        url += `&masterId=${encodeURIComponent(masterId.trim())}`;
      }
      if (userName && userName.trim() !== "") {
        url += `&userName=${encodeURIComponent(userName.trim())}`;
      }
      if (role && role.trim() !== "") {
        url += `&role=${encodeURIComponent(role.trim())}`;
      }

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return {
          data: data.data,
          currentPage: data.currentPage,
          totalPages: data.totalPages,
          totalItems: data.totalItems,
        };
      } else {
        console.error("API error response:", data); 
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      console.error("API error:", err.response?.data || err.message); 
      return thunkAPI.rejectWithValue(
        err.response?.data 
          ? { ...err.response.data, status: err.response.status }
          : { message: "Network error" }
      );
    }
  }
);
export const createSaleData = createAsyncThunk(
  "sales/create-sale",
  async (saleData, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/sales/save", saleData, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        if (typeof data === "string") {
          return { message: data };
        }
        return data;
      } else {
        return thunkAPI.rejectWithValue(
          typeof data === "string" ? { message: data } : data
        );
      }
    } catch (err) {
      const errorData = err.response?.data;
      return thunkAPI.rejectWithValue(
        typeof errorData === "string"
          ? { message: errorData }
          : errorData || { message: "Network error" }
      );
    }
  }
);

export const deleteSaleData = createAsyncThunk(
  "sales/delete-sale",
  async ({ id }, thunkAPI) => {
    try {
      
      
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

 

      const { data, status } = await axios.delete(`/sales/delete/${id}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });


      if (status.toString().startsWith("2")) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("Delete API error:", err); 
      return thunkAPI.rejectWithValue(
        err.response?.data || { message: "Network error" }
      );
    }
  }
);

export const editSaleData = createAsyncThunk(
  "sales/edit-sale",
  async (saleFormData, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;


      const { data, status } = await axios.put(
        `/sales/update`, 
        saleFormData,
        {
          headers: { 
            Authorization: `Bearer ${tokenStr}`,
            'Content-Type': 'multipart/form-data'
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || { message: err.message || "Network error" }
      );
    }
  }
);

export const salesSetupData = createAsyncThunk(
  "sales/setup-data",
  async (_, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const { data, status } = await axios.get("/sales/setup-sales-entry", {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || { message: "Network error" }
      );
    }
  }
);

const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    clearStateSales: (state) => {
      state.salesData = { data: [], currentPage: 0, totalPages: 0, totalItems: 0 };
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateCreateSale: (state) => {
      state.createSale = {};
      state.isSuccessCreateSale = false;
      state.isErrorCreateSale = false;
      state.isErrorMessageCreateSale = "";
    },
    clearStateDeleteSale: (state) => {
      state.deleteSale = {};
      state.isSuccessDeleteSale = false;
      state.isErrorDeleteSale = false;
      state.isErrorMessageDeleteSale = "";
    },
    clearStateEditSale: (state) => {
      state.editSale = {};
      state.isSuccessEditSale = false;
      state.isErrorEditSale = false;
      state.isErrorMessageEditSale = "";
    },
  },
  extraReducers: (builder) => {
    builder
    
      .addCase(getSalesData.fulfilled, (state, action) => {
        state.salesData = {
          data: action.payload?.data || [],
          currentPage: action.payload?.currentPage || 0,
          totalPages: action.payload?.totalPages || 0,
          totalItems: action.payload?.totalItems || 0,
        };
        state.isFetching = false;
        state.isSuccess = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getSalesData.pending, (state) => {
        state.isFetching = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getSalesData.rejected, (state, action) => {
        state.salesData = { data: [], currentPage: 0, totalPages: 0, totalItems: 0 };
        state.isFetching = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMessage = action.payload?.message || "Internal error";
      })

      
      .addCase(createSaleData.fulfilled, (state, action) => {
        state.createSale = action.payload || {};
        state.isFetching = false;
        state.isSuccessCreateSale = true;
        state.isErrorCreateSale = false;
        state.isErrorMessageCreateSale = "";
      })
      .addCase(createSaleData.pending, (state) => {
        state.isFetching = true;
        state.isErrorCreateSale = false;
        state.isErrorMessageCreateSale = "";
      })
      .addCase(createSaleData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorCreateSale = true;
        state.isSuccessCreateSale = false;
        state.isErrorMessageCreateSale =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message || "Internal error";
      })

     
      .addCase(deleteSaleData.fulfilled, (state, action) => {
        state.deleteSale = action.payload || {};
        state.isFetching = false;
        state.isSuccessDeleteSale = true;
        state.isErrorDeleteSale = false;
        state.isErrorMessageDeleteSale = "";
        
        if (
          state.salesData.data.length === 1 &&
          state.salesData.currentPage > 0
        ) {
          state.salesData.currentPage -= 1;
        } else if (state.salesData.data.length === 1) {
          state.salesData = { data: [], currentPage: 0, totalPages: 0, totalItems: 0 };
        }
      })
      .addCase(deleteSaleData.pending, (state) => {
        state.isFetching = true;
        state.isErrorDeleteSale = false;
        state.isErrorMessageDeleteSale = "";
      })
      .addCase(deleteSaleData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorDeleteSale = true;
        state.isSuccessDeleteSale = false;
        state.isErrorMessageDeleteSale = action.payload?.message || "Internal error";
      })

    
      .addCase(editSaleData.fulfilled, (state, action) => {
        state.editSale = action.payload || {};
        state.isFetching = false;
        state.isSuccessEditSale = true;
        state.isErrorEditSale = false;
        state.isErrorMessageEditSale = "";
      })
      .addCase(editSaleData.pending, (state) => {
        state.isFetching = true;
        state.isErrorEditSale = false;
        state.isErrorMessageEditSale = "";
      })
      .addCase(editSaleData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorEditSale = true;
        state.isSuccessEditSale = false;
        state.isErrorMessageEditSale = action.payload?.message || "Internal error";
      })

      .addCase(salesSetupData.pending, (state) => {
        state.isFetchingUserList = true;
      })
      .addCase(salesSetupData.rejected, (state) => {
        state.isFetchingUserList = false;
      })
      .addCase(salesSetupData.fulfilled, (state) => {
        state.isFetchingUserList = false;
      });
  },
});

export const {
  clearStateSales,
  clearStateCreateSale,
  clearStateDeleteSale,
  clearStateEditSale,
} = salesSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateSales());
  };
}

export function clearStateCreate() {
  return async (dispatch) => {
    dispatch(clearStateCreateSale());
  };
}

export function clearStateDelete() {
  return async (dispatch) => {
    dispatch(clearStateDeleteSale());
  };
}

export function clearStateEdit() {
  return async (dispatch) => {
    dispatch(clearStateEditSale());
  };
}

export const salesSelector = (state) => state.sales;

export default salesSlice.reducer;
